export default {
  type: 'file_upload',
  config: null
};
//# sourceMappingURL=file_upload.js.map